<template>
  <MainHeader></MainHeader>
  <div class="makeuser">
    <h1 class="text-center mt-12">{{ $t('makeuser.title') }}</h1>

    <v-form ref="form">
      <v-container>
        <!-- カテゴリーの入力欄 -->
        <v-row v-for="(item, index) in translated_category_list" :key="index" justify="center">
          <v-col cols="12" sm="10" md="8">
            <v-text-field v-model="item.name" prepend-inner-icon="mdi-shape" :label="$t('makeuser.category')"
              variant="outlined" :rules="nameRules"></v-text-field>
          </v-col>
        </v-row>

        <!-- ボタンを下に配置し、中央に揃える -->
        <v-row justify="center" class="mt-6 mb-6">
          <v-col cols="12" sm="6" md="4">
            <v-btn block color="success" @click="makeuser">
              {{ $t('makeuser.start') }}
            </v-btn>
          </v-col>
        </v-row>
        <!-- 軽めのメッセージ表示 -->
        <p class="info-text mt-2 mb-4">
          {{ $t('makeuser.subtitle') }}
        </p>
      </v-container>

    </v-form>
  </div>
</template>

<script>
import MainHeader from '@/components/MainHeader.vue';

export default {
  name: 'MakeUserView',
  components: {
    MainHeader
  },
  data() {
    return {
      nameRules: [
        v => !!v || 'カテゴリは必須です'
      ],
      translated_category_list: []
    };
  },
  async mounted() {
    await this.make_transelate_categorylist();
  },
  watch: {
    '$i18n.locale': function () {
      this.make_transelate_categorylist();
    },
  },
  methods: {
    async make_transelate_categorylist() {
      let no_translate_category_list = [
        { order: 1, cat_id: "cat1", name: "category_list1" },
        { order: 2, cat_id: "cat2", name: "category_list2" },
        { order: 3, cat_id: "cat3", name: "category_list3" },
        { order: 4, cat_id: "cat4", name: "category_list4" },
        { order: 5, cat_id: "cat5", name: "category_list5" },
        { order: 6, cat_id: "cat6", name: "category_list6" },
        { order: 7, cat_id: "cat7", name: "category_list7" },
        { order: 8, cat_id: "cat8", name: "category_list8" }
      ];

      this.translated_category_list = no_translate_category_list.map(cat => ({
        ...cat,
        name: this.$t(cat.name)
      }));
    },
    async makeuser() {
      let jsonbody = {
        api_type: "makeuser",
        user_id: this.$store.state.user_info.pre_user_id,
        category: this.translated_category_list
      };

      try {
        await this.axios.post(this.$store.state.api_baseurl + "makeuser", jsonbody, this.$store.state.post_headers);
        this.$store.commit("set_user_info", this.$store.state.user_info.pre_user_id);
        this.$store.commit("set_category_list", this.translated_category_list);
        this.$router.push({ name: "itemlist" });
      } catch (e) {
        alert(e);
      }
    },
  }
}
</script>

<style scoped>
.makeuser {
  padding: 20px;
}

.text-center {
  text-align: center;
}

.v-btn {
  font-size: 16px;
}

.v-alert {
  border-radius: 8px;
  font-size: 14px;
  text-align: center;
}
</style>
